<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="12">
            受试者：{{baseInfo.patientNum}}-{{baseInfo.patientName}}
          </a-col>
          <a-col :span="12">
            <a-form-item label="索引名称">
              <a-input size="small" placeholder="请输入索引名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="索引值">
              <a-input size="small" placeholder="请输入索引值" v-model="queryParam.value"></a-input>
            </a-form-item>
          </a-col>

            <a-col :span="12">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" size="small" @click="loadDataMy" icon="search">查询</a-button>
                  <a-button type="primary" size="small"  @click="searchResetMy" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAddMy" size="small" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.empi)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <empiPix-modal ref="modalForm" @ok="modalFormOk"></empiPix-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import EmpiPixModal from '../modules/EmpiPixModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "EmpiPixList",
    mixins:[JeecgListMixin],
    components: {
      EmpiPixModal
    },
    props:{
    },
    data () {
      return {
        description: '交叉主索引管理页面',
        baseInfo:{},
        // 表头
        columns: [
		   // {
       //      title: 'ID',
       //      align:"center",
       //      dataIndex: 'empi'
       //     },
		   // {
       //      title: '队列中的患者ID',
       //      align:"center",
       //      dataIndex: 'projectPatientId'
       //     },
		   // {
       //      title: '队列ID',
       //      align:"center",
       //      dataIndex: 'projectId'
       //     },
		   {
            title: '索引名称',
         ellipsis: true, //表格省略
         align:"center",
            dataIndex: 'name'
           },
		   {
            title: '索引值',
         ellipsis: true, //表格省略
         align:"center",
            dataIndex: 'value'
           },
		   {
            title: 'CODE',
         ellipsis: true, //表格省略
         align:"center",
            dataIndex: 'code'
           },
		   // {
       //      title: '被合并后的原始empi（拆分用）',
       //      align:"center",
       //      dataIndex: 'baseEmpi'
       //     },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            width:100,
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/management/empiPix/list",
          delete: "/management/empiPix/delete",
       },
        selectedRowKeys:[],
        selectionRows:[],
    }
  },
  computed: {

  },
    watch:{

    },
    mounted(){
      this.loadDataMy()
    },
    methods: {
      loadDataByBaseInfo(baseInfo){
        this.baseInfo = Object.assign({},baseInfo)
        this.loadDataMy()
      },
      loadDataMy(){
        this.dataSource = []
        if(this.baseInfo.empi && this.baseInfo.projectPatientId){
          this.baseQueryParam = {empi:this.baseInfo.empi,projectPatientId:this.baseInfo.projectPatientId}
          this.loadData()
        }
      },
      handleAddMy(){
        this.handleEdit(this.baseInfo)
      },
      searchResetMy(){
        this.queryParam = {}
        this.ipagination.current = 1;
        this.loadDataMy()
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>